import { EGenplanInfrastructureCategory } from '../newbuilding/genplan';
import { EPromoType } from '../newbuilding/promos';

export interface IProduct {
  offerType?: string;
  brand?: string;
  consultant?: boolean;
  dealType?: string;
  id: number;
  name?: string;
  nv?: boolean;
  objectType?: string;
  position: number;
  extra?: TExtra;
}

export interface IPromoIdExtraObject {
  promo_type: EPromoType;
  promo_cian_mortgage?: string;
  promo_id: number;
  position: number;
}

export enum EGenplanControlsType {
  Floor = 'on_floor',
  Panorama = 'panorama',
}

export type TExtra =
  | {
      cplCalltracking?: number;
      cplDynamicCalltracking?: number;
    }
  | {
      label: string;
      promotion_id: number;
      promo_cian_mortgage: string;
    }
  | {
      promoId?: number;
      promoCianMortgage?: string;
    }
  | {
      corpus_id?: number;
    }
  | {
      corpus_id?: number;
      room_num?: string;
    }
  | {
      bankId: number;
      bank_name: string;
    }
  | {
      promoId: string;
      position: number;
    }
  | {
      promoId: IPromoIdExtraObject[];
    }
  | {
      promoId: string[];
    }
  | {
      promotion_id: number;
    }
  | {
      type: EGenplanControlsType | EGenplanInfrastructureCategory;
    };
